import React from 'react';

import { HStack, Box } from '@vimeo/bokeh';

interface RowRenderIfSpaceProps {
  childrenShowing: boolean[];
  disableScroll?: boolean;
  children: React.ReactNode;
}
/**
 * Uses the childrenShowing array returned from useShouldShowChildren to hide a child when there isn't space for it, this only applies on desktop when x-axis scroll is disabled.
 * Uses CSS Visibility so that the element is not removed from the dom. This allows us to keep track of
 * the elements size and to show again when space is available.
 */
export const RowRenderIfSpace = React.forwardRef(
  (
    { childrenShowing, disableScroll = true, children }: RowRenderIfSpaceProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    // Filter out null children
    const filteredChildren = React.Children.toArray(children).filter((child) => child !== null);

    return (
      <HStack ref={ref} py={75} overflowX={disableScroll ? 'hidden' : 'auto'} overflowY="hidden">
        {filteredChildren.map((child, index) => {
          const isHidden = !childrenShowing[index] && disableScroll;

          return (
            <Box key={index} visibility={isHidden ? 'hidden' : 'visible'}>
              {child}
            </Box>
          );
        })}
      </HStack>
    );
  },
);
